export const FB_APP_ID = '2883438961931896'
export const FB_SCOPE
    = 'email, ads_management, pages_read_engagement, public_profile'
export const YT_CLIENT_ID
    = '814843957899-umn9j9vn109f6fugiv1j2a5b7j2bdl5u.apps.googleusercontent.com'
export const YT_SCOPE
    = 'https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/youtubepartner https://www.googleapis.com/auth/youtube.force-ssl'
export const YT_HOSTED_DOMAIN = 'ggs-stp.com'
